// extracted by mini-css-extract-plugin
export default {"con":"PopUpInfo_con__HB5r4","heading":"PopUpInfo_heading__iCLql","hr":"PopUpInfo_hr__VNWqe","para1":"PopUpInfo_para1__6gU1n"};